export const checkPermission = (basePermission: number, permission: number) => {
  return (basePermission & permission) === permission;
};
